<script>
    import { Circle } from "svelte-loading-spinners";
</script>

<div class="loading-wrapper">
    <div
        style="display: flex; flex-direction: row; justify-content: center; width: 100%;"
    >
        <Circle size="128" color="var(--black-100)" />
    </div>
</div>

<style>
    .loading-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
